// src/components/PageContainer.tsx
import React from "react";

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Shared outer rounded container used across all diagnosis/visit pages.
 * Sits next to <Sidebar /> inside the root flex row.
 */
const PageContainer: React.FC<PageContainerProps> = ({ children, className = "" }) => (
  <main
    className={`flex-1 min-w-0 bg-white rounded-2xl lg:rounded-3xl shadow-sm ${className}`}
  >
    {children}
  </main>
);

export default PageContainer;
